import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export enum EventType {
    FileUploaded = 0
}

@Injectable({
    providedIn: 'root'
})
export class SharedEventService {
    private selectedItemSource = new BehaviorSubject<EventType>(null);
    public selectedItem$ = this.selectedItemSource.asObservable();

    public sendEvent(event: EventType) {
        this.selectedItemSource.next(event);
    }
}
